import cn from 'classnames';

import ContentContainer from 'components/content-container/ContentContainer';
import SimpleHeader from 'components/header/SimpleHeader';

import { INewsletterAdministrationLayout } from 'source/NFR.types';

interface INewsletterAdministrationLayoutProps extends INewsletterAdministrationLayout {
  className?: string;
}

const NewsletterAdministrationLayout: React.FC<React.PropsWithChildren<INewsletterAdministrationLayoutProps>> = ({
  children,
  className,
  header
}) => (
  <div className={cn('newsletter-administration-layout', className)}>
    {header && <SimpleHeader {...header} />}
    <ContentContainer theme="narrow">{children}</ContentContainer>
  </div>
);

NewsletterAdministrationLayout.displayName = 'NewsletterAdministrationLayout';

export default NewsletterAdministrationLayout;
